import React, { useState } from 'react';
import styles from './RelatorioCollapse.module.scss';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { isEmpty } from '../../../../core/utils/ValidForm';
import arquivoIntegracaoService from '../../../../service/integracao/ArquivoIntegracaoService';

function Rotulo({ title, descricao }) {
    return (
        <div>
            <div className={title ? '' : styles.emptyLabel}>{title ?? '.'}</div>
            <div className={styles.descriptionLabel}>{descricao}</div>
        </div>
    );
}

function RelatorioCollapse({ status, situacao, dataCadastro, usuarioCadastro, file }) {
    const [arquivo, setArquivo] = useState(null);
    const [message, setMessage] = useState('...');
    const Header = () => (
        <div className={styles.header}>
            <Rotulo
                title={status}
                descricao={`Data: ${dataCadastro ?? ''} - ${usuarioCadastro ?? ''}`}
            />
            <Rotulo descricao={`Situação da Proposta: ${situacao}`} />
        </div>
    );
    const Empty = () => (
        <div className={`${styles.empty} ${message !== '...' ? styles.textFormat : ''}`}>
            {message}
        </div>
    );

    return (
        <Accordion
            className={`p-col-12 ${styles.noPaddingRight}`}
            collapseIcon="pi pi-angle-double-down"
            expandIcon="pi pi-angle-double-left"
            onTabOpen={() => {
                if (!isEmpty(file?.id) && isEmpty(arquivo)) {
                    arquivoIntegracaoService
                        .getArquivoById(file?.id)
                        .then(async (response) => {
                            setArquivo(window.URL.createObjectURL(response));
                        })
                        .catch(async (err) => {
                            const json = await err.response.data.text();
                            const response = JSON.parse(json);
                            setMessage(response?.message);
                        });
                }
            }}
        >
            <AccordionTab className={styles.accordion} header={<Header />}>
                {arquivo ? <object type="application/pdf" data={arquivo}></object> : <Empty />}
            </AccordionTab>
        </Accordion>
    );
}

export default RelatorioCollapse;
